import { useEffect, useState } from "react";
import { Loader2, ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";
import { AppShell } from "@/components/dash/AppShell";
import { AdminStats } from "@/components/admin/AdminStats";
import { ExpiringComps } from "@/components/admin/ExpiringComps";
import { AccountFilters } from "@/components/admin/AccountFilters";
import { AccountsList } from "@/components/admin/AccountsList";

const useDebounced = (value, ms = 300) => {
  const [v, setV] = useState(value);
  useEffect(() => { const t = setTimeout(() => setV(value), ms); return () => clearTimeout(t); }, [value, ms]);
  return v;
};

export default function Admin() {
  const [f, setF] = useState({ q: "", status: "", sort: "created_at", order: "desc", include_tests: false });
  const [overview, setOverview] = useState(null);
  const [accounts, setAccounts] = useState(null);
  const q = useDebounced(f.q);
  const set = (patch) => setF((x) => ({ ...x, ...patch }));

  useEffect(() => {
    api.get("/admin/overview", { params: { include_tests: f.include_tests } }).then(({ data }) => setOverview(data));
  }, [f.include_tests]);
  useEffect(() => {
    api.get("/admin/accounts", { params: { q, status: f.status, sort: f.sort, order: f.order, include_tests: f.include_tests } })
      .then(({ data }) => setAccounts(data));
  }, [q, f.status, f.sort, f.order, f.include_tests]);

  return (
    <AppShell allowInactive>
      <div className="space-y-5" data-testid="admin-page">
        <div>
          <h1 className="flex items-center gap-2 text-2xl font-bold tracking-tight text-foreground"><ShieldCheck className="h-6 w-6" />Admin</h1>
          <p className="mt-1 text-sm text-muted-foreground">Accounts, revenue and usage across Squadrum{f.include_tests ? " (including test accounts)" : ""}.</p>
        </div>
        {overview ? <><AdminStats data={overview} /><ExpiringComps items={overview.expiring_comps} /></>
          : <div className="flex h-40 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div>}
        <section className="space-y-3">
          <div className="flex items-baseline justify-between">
            <h2 className="text-base font-semibold text-foreground">Accounts</h2>
            {accounts && <span className="text-sm text-muted-foreground" data-testid="admin-accounts-total">{accounts.total} shown</span>}
          </div>
          <AccountFilters f={f} set={set} />
          {accounts ? <AccountsList items={accounts.items} /> : <div className="h-40 animate-pulse rounded-2xl bg-muted" />}
        </section>
      </div>
    </AppShell>
  );
}
